export default __webpack_public_path__ + "static/media/pt_br.a679b973.png";